import {CSSProperties, FC} from 'react';


export interface IIconInfo2Props {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconInfo2: FC<IIconInfo2Props> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M5.4 9h1.2V5.4H5.4V9ZM6 4.2c.17 0 .313-.058.428-.173A.578.578 0 0 0 6.6 3.6a.583.583 0 0 0-.173-.427A.579.579 0 0 0 6 3a.579.579 0 0 0-.427.173.583.583 0 0 0-.173.427c0 .17.057.312.173.428A.576.576 0 0 0 6 4.2ZM6 12a5.84 5.84 0 0 1-2.34-.473 6.068 6.068 0 0 1-1.905-1.282A6.046 6.046 0 0 1 .473 8.34 5.856 5.856 0 0 1 0 6c0-.83.157-1.61.473-2.34a6.073 6.073 0 0 1 1.282-1.905A6.05 6.05 0 0 1 3.66.473 5.845 5.845 0 0 1 6 0c.83 0 1.61.158 2.34.473a6.05 6.05 0 0 1 1.905 1.282c.54.54.967 1.175 1.283 1.905.316.73.473 1.51.472 2.34a5.883 5.883 0 0 1-.473 2.34 6.02 6.02 0 0 1-1.282 1.905c-.54.54-1.176.967-1.905 1.283C7.61 11.843 6.83 12 6 12Z" />
        </svg>
    );
};
